module.exports = __webpack_public_path__ + "static/img/团队成员-李宝文.8126dfb7.jpg";